export default "__VITE_ASSET__BMKGdCLi__"